import { Grid } from "@mui/material";
import { Fragment } from "react";

import OmniLoginPage from "../component/app/omniService/OmniLogin.component";

const OmniServicePage = () => {
  return (
    <Fragment>
      <Grid container sx={{ height: "100vh", backgroundColor: "#fafffc" }}>
        <Grid md={4} />
        <Grid
          item
          md={4}
          xs={12}
          sx={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <OmniLoginPage />
        </Grid>
        <Grid md={4} />
      </Grid>
    </Fragment>
  );
};
export default OmniServicePage;
